export default __webpack_public_path__ + "static/media/ar.e2374711.svg";